import styled, {keyframes} from "styled-components";

export const ValidationStyle = styled.div`
    height: 100%;
    width: 100%;
    background-color: #E5F8FA;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`

export const WrapContent = styled.div`
    width: 75%;
    height: 80%;
    display: flex;
    flex-direction: column;
    padding: 40px;
`

export const SesiImage = styled.img`
    width: 200px;
    height: 90px;
    margin: 0;
`

export const HeaderRow = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;

    h1{
        color: #FF5742;
        font-size: 20px;
        font-weight: 900;
        margin: 0;
    }

    h2{
        margin: 0;
        color: #005CA9;
        font-size: 20px;
        font-weight: 500;
    }
`

export const HeaderCollum = styled.div`
    display: flex;
    flex-direction: column;
`

export const WrapTitleAndButtons = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
`

export const DenyButton = styled.button`
    width: 160px;
    height: 60px;
    border: none;
    border-radius: 30px;
    background-color: #FEA69B;
    color: black;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

    &:hover {
        box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
    }
`

export const SelectAllButton = styled.button`
    width: 200px;
    height: 60px;
    border: none;
    border-radius: 15px;
    background-color: #E0E0E0;
    color: black;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;
    font-size: 20px;
    align-items: center;
    justify-content: center;

    &:hover {
        box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
    }
`

export const WrapButtons = styled.div`
    display: flex;
    flex-direction: row;
    gap: 10px;
`

export const AcceptButton = styled.button`
    width: 160px;
    height: 60px;
    border: none;
    border-radius: 30px;
    background-color: #428EFF;
    color: black;
    cursor: pointer;
    transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

    &:hover {
        box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
    }
`

export const ValidationTitle = styled.h1`
    color: #005CA9;
    font-weight: 700;
    font-size: 45px;
    text-align: start;
    width: 200px;
`

export const WrapAdesao = styled.div`
    display: flex;
    flex-direction: column;
    flex-grow: 1;  
    min-height: 500px;
    max-height: 80vh; 
    overflow-y: auto;
    gap: 20px;
    width: 100%; 
    padding: 10px;
`;

export const LeftContent = styled.div`
    display: flex;
    flex-direction: column;

    h2{
        font-size: 18px;
        font-weight: 600;
        color: black;
        margin-left: 50px;
        margin-top: 0;
        margin-bottom: 0;
    }
`

export const RightContent = styled.div`
    display: flex;
    flex-direction: column;

    h1{
        color: #FF5742;
        font-size: 20px;
        font-weight: 700;
        margin-right: 80px;
    }
`
export const SelectionIndicator = styled.div<{ selected: boolean }>`
  width: 20px;
  height: 20px;
  background-color: ${({ selected }) => (selected ? "#087CDE" : "#C4C4C4")};
  border-radius: 50%;
  position: absolute;
  top: 45%;
  right: 15px;
`;

export const AdesaoCard = styled.div`
  width: 100%;
  min-height: 130px; 
  background-color: #F7F7F7;
  border-radius: 30px;
  box-shadow: 0 4px 4px rgba(0, 0, 0, 0.1);
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  position: relative; 
  cursor: pointer;
  flex-shrink: 0; 

  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 6px 10px rgba(0, 0, 0, 0.2);
  }
`;

export const BackButton = styled.button`
  position: absolute;
  top: 20px;
  left: 20px;
  background: none;
  border: none;
  color: red;
  font-size: 16px;
  cursor: pointer;
  display: flex;
  align-items: center;

  &:hover {
    color: #003f7d;
  }

  svg {
    margin-right: 5px;
  }

`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ModalContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  background: white;
  padding: 50px;
  border-radius: 8px;
  text-align: center;
  width: 300px;
`;

export const ModalInput = styled.input`
  width: 100%;
  padding: 8px;
  height: auto;
`;

export const ModalTextarea = styled.textarea`
  width: 100%;
  padding: 8px;
  height: auto;
  min-height: 40px; /* Altura inicial */
  max-height: 200px; /* Altura máxima para evitar crescimento excessivo */
  resize: none; /* Impede redimensionamento manual */
  overflow-y: hidden; /* Esconde barra de rolagem enquanto cresce */
`;

export const ModalButtons = styled.div`
  display: flex;
  justify-content: space-between;
  margin-top: 10px;
  gap: 80px;
  
  button {
    padding: 8px 12px;
    border: none;
    cursor: pointer;
    font-size: 16px;

    &:hover{
        background-color: #E0E0E0;
    }
  }
`;

export const Select = styled.select`
  padding: 10px;
  border: 1px solid #ccc;
  border-radius: 5px;
  width: 20%;
  background: white;
  cursor: pointer;
`;

export const spin = keyframes`
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
`;


export const LoadingOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.6);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 9999;
`;

export const Spinner = styled.div`
  width: 60px;
  height: 60px;
  border: 6px solid #fff;
  border-top: 6px solid transparent;
  border-radius: 50%;
  animation: ${spin} 1s linear infinite;
`;

